import HelperSetup from '../Helper/HelperSetup';
var initializeApplicationHelper = function () {
    HelperSetup.initialApplicationSetup();
};
export default initializeApplicationHelper;
